module.exports = __webpack_public_path__ + "5788e7ee739f4c61b414f9770473deb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logoBalestra_transparent.png
// module id = 410
// module chunks = 0